import React from 'react'
import styled from 'styled-components'
import colors from '../../constants/colors'

export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 36px;
  z-index: 0;
  height: 20px;
  border-radius: 15px;
  background: ${colors.black25};
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    margin: 2px;
    background: ${colors.white};
    transition: 0.2s;
  }
`
export const CheckBox: React.FC<React.HTMLProps<HTMLInputElement>> = styled.input<
  React.HTMLProps<HTMLInputElement>
>`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 36px;
  height: 20px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  margin: 0;
  &:checked + ${CheckBoxLabel} {
    background: ${colors.blue50};
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      margin-left: 18px;
      transition: 0.2s;
    }
  }
  &:disabled + ${CheckBoxLabel} {
    opacity: 0.25;
  }
`
